import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";
import { requestContentPages } from "~/store/resource/resourceAction";
import { Delpath } from "~/utils/constants";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const TermsOfServicePage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/TermsOfServiceTest"
    ),
  loading: LoadableLoading
});
class DetectTermsOfService extends Component {
  componentDidMount() {
    const pathName = Delpath(this.props.location.pathname);
    this.props.requestContentPages(pathName);
  }

  render() {
    return (
      <React.Fragment>
        <TermsOfServicePage {...this.props} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    resource: { ContentPages }
  } = state;
  return {
    ContentPages
  };
};
const mapDispatchToProps = dispatch => {
  return {
    requestContentPages: pathName => dispatch(requestContentPages(pathName)) // có
  };
};
const TermsOfServiceHelmet = withTitle({
  component: DetectTermsOfService,
  title: `${hospitalName.value} | Điều khoản dịch vụ`
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsOfServiceHelmet);
